export default "__VITE_ASSET__oOGoq1HT__"